import styled from "styled-components"

const ExpandedMenuMobile2 = () => {
  return (
    <ExpandedMenuDiv>
      <SubMenuDiv>FAQ</SubMenuDiv>
      <SubMenuDiv>Q&A</SubMenuDiv>
      <SubMenuDiv>서비스 문의</SubMenuDiv>
    </ExpandedMenuDiv>
  )
}

export default ExpandedMenuMobile2

const ExpandedMenuDiv = styled.div`
  display: flex;
  flex-direction: column;
`

const SubMenuDiv = styled.div`
  height: 40px;
  font-size: 16px;
  line-height: 40px;
`
